import { Plus, Minus } from 'lucide-react';
import React from 'react';

const MovementPanel = ({ amount, note, dispatch }) => (
    <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-4 text-center bg-gray-50/30 p-8 rounded-[3rem] border border-gray-100 shadow-inner">
            <label htmlFor="inv-operate-amount" className="text-[10px] font-black uppercase tracking-[0.3em] text-gray-400">Amount to Operate</label>
            <div className="flex items-center justify-center gap-8 py-2">
                <button
                    type="button"
                    onClick={() => dispatch({ type: 'SET_FIELD', field: 'amount', value: Math.max(1, amount - 1) })}
                    className="w-20 h-20 bg-white border border-gray-100 text-gray-400 rounded-3xl font-black text-3xl hover:text-primary hover:shadow-xl hover:scale-110 transition-all active:scale-90 shadow-sm"
                >
                    -
                </button>
                <div className="relative group">
                    <input
                        id="inv-operate-amount"
                        type="number"
                        value={amount}
                        onChange={(e) => dispatch({ type: 'SET_FIELD', field: 'amount', value: Math.abs(Number(e.target.value)) })}
                        className="w-40 py-8 bg-transparent border-b-4 border-accent/20 outline-none text-center font-black text-7xl text-primary focus:border-accent transition-all tabular-nums"
                    />
                </div>
                <button
                    type="button"
                    onClick={() => dispatch({ type: 'SET_FIELD', field: 'amount', value: amount + 1 })}
                    className="w-20 h-20 bg-accent text-white rounded-3xl font-black text-3xl hover:shadow-[0_20px_40px_-10px_rgba(255,184,0,0.4)] hover:scale-110 transition-all active:scale-90"
                >
                    +
                </button>
            </div>
        </div>
        <div className="flex flex-col gap-3">
            <label htmlFor="inv-audit-notes" className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1 italic">Audit Notes (Optional)</label>
            <textarea
                id="inv-audit-notes"
                value={note}
                onChange={(e) => dispatch({ type: 'SET_FIELD', field: 'note', value: e.target.value })}
                placeholder="e.g., Withdrawal for pump #402 repair..."
                className="w-full px-8 py-6 bg-gray-50/50 border-2 border-transparent rounded-[2.5rem] outline-none focus:bg-white focus:border-accent/30 resize-none min-h-[160px] font-bold text-gray-600 text-xl transition-all shadow-inner"
            />
        </div>
    </div>
);

export default MovementPanel;
